"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var Spinner_1 = require("./Spinner");
var Loading = function (_a) {
    var className = _a.className;
    return ((0, jsx_runtime_1.jsx)(Root, __assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(core_1.CardContent, { children: (0, jsx_runtime_1.jsx)(Spinner_1["default"], { size: 24, width: 'auto' }) }) })));
};
var Root = (0, styles_1.styled)(core_1.Card)({
    height: '100%'
});
exports["default"] = Loading;
